export enum ClientContactSource{
    faceads='faceads',
    facewhatsappads='face_whatsapp_ads',
    shot='shot',
    direct='direct',
    others='others',
    unknwon='unknown',
 }
export function clientContactSourceToPTBR(s:string|ClientContactSource){
   switch(s){
      case ClientContactSource.faceads:
        return "Anuncio Face";
      case ClientContactSource.direct:
        return "Contato Direto";
      case ClientContactSource.shot:
         return "Disparo";
      case ClientContactSource.facewhatsappads:
         return "Anuncio Direto WhatsApp";
      case ClientContactSource.unknwon:
          return "Indeterminado";
      case ClientContactSource.others:
          return "Indeterminado";       
      case 'autofgts':
          return "Site/App (autofgts)";
   }
   return s;
} 

/** Canal em que a proposta nasceu (chat_source do backend). Antigas vêm sem canal. */
export function chatSourceToPTBR(s?:string|null){
   switch(s){
      case 'whatsapp': return "WhatsApp";
      case 'instagram': return "Instagram";
      case 'evolution': return "WhatsApp (Evolution)";
      case 'telegram': return "Telegram";
      case 'autofgts': return "Site/App (autofgts)";
      case 'autoclt': return "Site (autoclt)";
   }
   return "Sem canal (antigas)";
}